<template>
  <div>
    <breadcrumb />
    <br />
    <v-card raised>
      <form @submit.prevent="sendFile" multipart="true">
        <v-layout row wrap justify-space-between pa-4>
          <v-flex xs12 md4>
            <v-text-field
              v-model="birth.child_name"
              :error-messages="nameErrors"
              :counter="30"
              label="Nombre del recién nacido"
              required
              @input="$v.birth.child_name.$touch()"
              @blur="$v.birth.child_name.$touch()"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="birth.child_lastname"
              :error-messages="lastnameErrors"
              :counter="30"
              label="Apellido paterno"
              required
              @input="$v.birth.child_lastname.$touch()"
              @blur="$v.birth.child_lastname.$touch()"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="birth.child_lastname2"
              :error-messages="lastname2Errors"
              :counter="30"
              label="Apellido materno"
              required
              @input="$v.birth.child_lastname2.$touch()"
              @blur="$v.birth.child_lastname2.$touch()"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md6 sm12 xs12>
            <autocomplete-user 
              @set-user-name="setFatherName" 
              labelName="Padre o Madre del recién nacido"
              :user_id="user_id"
              :validator="$v.birth"
            />
          </v-flex>
          <v-flex xs12 sm4>
            <v-checkbox
              v-model="birth.is_public"
              label="¿Publicar en la intranet?"
              color="#211850"
            />
          </v-flex>
          <v-flex xs12 sm3>
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="birthday"
              persistent
              lazy
              full-width
              width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="birthday"
                label="Fecha de nacimiento"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-flex xs12 sm4>
                <v-date-picker v-model="birth.birthday" :format="formatDate(birth.birthday)" locale="es" color="#638d37">
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modal = false">Cancelar</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog.save(birthday)">Ok</v-btn>
                </v-date-picker>
              </v-flex>
            </v-dialog>
          </v-flex>
          <v-flex xs12 sm3>
            <v-radio-group v-model="birth.gender" row>
              <v-radio
                v-for="option in options"
                :key="option.index"
                :label="`${option.text}`"
                :value="option.value"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs6 md6 sm12 xs12>
            <h2 class="subheading">Subir foto del recién nacido:</h2>
            <input type="file" ref="files" accept="image/*" @change="selectFiles()" required />
            <br />
            <br />
            <span style="color: red;">
              Formato de imágenes permitidas: jpg, png y svg.
              <br />Por favor elegir un ancho mayor a 250 y un alto mayor a 200
            </span>
          </v-flex>
          <v-flex md12 sm12 xs12 text-xs-right>
            <v-btn type="submit" class="white--text" color="#638d37">Crear Nacimiento</v-btn>
            <v-btn @click="clear">Limpiar</v-btn>
          </v-flex>
        </v-layout>
      </form>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapState } from "vuex";
import Breadcrumb from "@/components/General/Breadcrumb";
import AutocompleteUser from "@/components/General/AutocompleteUser";
import {
  required,
  minLength,
  email,
  maxLength
} from "vuelidate/lib/validators";
import {} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  mixins: [validationMixin],
  components: {
    Breadcrumb,
    AutocompleteUser
  },
  data() {
    return {
      child_name: "",
      child_lastname: "",
      child_lastname2: "",
      selected: true,
      is_public: true,
      options: [
        { text: "Masculino", value: true },
        { text: "Femenino", value: false }
      ],
      birthday: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      user_id: '',
      full_name_mother: "",
      files: []
    };
  },
  props: {
    birth: {
      type: Object,
      required: true
    },
    birthSubmit: {
      type: String,
      default: "Crear Nacimiento"
    }
  },
  validations: {
    birth: {
      child_name: { required, minLength: minLength(3) },
      // birthday: {required},
      user_id: { required },
      child_lastname: { required, minLength: minLength(3) },
      child_lastname2: { required, minLength: minLength(3) },
      gender: { required }
    }
  },
  computed: {
    ...mapState("user", ["current_user"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.birth.child_name.$dirty) return errors;
      !this.$v.birth.child_name.minLength &&
        errors.push("El Nombre debe tener mínimo 3 letras.");
      !this.$v.birth.child_name.required &&
        errors.push("El Nombre es requerido.");
      return errors;
    },
    lastnameErrors() {
      const errors = [];
      if (!this.$v.birth.child_lastname.$dirty) return errors;
      !this.$v.birth.child_lastname.minLength &&
        errors.push("El Apellido debe tener mínimo 3 letras.");
      !this.$v.birth.child_lastname.required &&
        errors.push("El Apellido es requerido.");
      return errors;
    },
    lastname2Errors() {
      const errors = [];
      if (!this.$v.birth.child_lastname2.$dirty) return errors;
      !this.$v.birth.child_lastname2.minLength &&
        errors.push("El Apellido debe tener mínimo 3 letras.");
      !this.$v.birth.child_lastname2.required &&
        errors.push("El Apellido es requerido.");
      return errors;
    },
  },
  methods: {
    formatDate(date){
      var moment = require('moment');
      this.birthday = moment(date).format("DD-MM-YYYY")
    },
    setFatherName(value) {
      this.user_id = value;
      this.birth.user_id = value;
    },
    setMotherName(e) {
      this.birth.full_name_mother = e;
    },
    clear() {
      this.$v.birth.$reset();
      this.birth.child_name = "";
      this.birth.child_lastname = "";
      this.birth.child_lastname2 = "";
      this.birth.user_id = "";
      this.birth.full_name_mother = "";
      this.user_id = "";
    },
    submit() {
      this.birth.$v.$touch();
    },
    sendFile() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      Swal.fire({ title: "Estamos cargando su petición..." });
      Swal.showLoading();
      const formData = new FormData();
      for (let key in this.files) {
        formData.append("images[" + key + "]", this.files[key]);
      }
      formData.append("birth[child_name]", this.birth.child_name);
      formData.append("birth[child_lastname]", this.birth.child_lastname);
      formData.append("birth[child_lastname2]", this.birth.child_lastname2);
      formData.append("birth[birthday]", this.birth.birthday);
      formData.append("birth[user_id]", this.user_id);
      formData.append("birth[gender]", this.birth.gender);
      formData.append("birth[is_public]", this.birth.is_public);
      formData.append("birth[approved]", false); 
      if (this.birth.user_id > 0)
      {
        try {
          axios.post("/frontend/births", formData);
          Swal.fire({
            customClass: {
              title: 'title-class'
            },
            title:
              "¡Gracias! Hemos recibido la información. Te confirmaremos por correo cuando el nacimiento esté publicado."
          });
          this.$router.push("/");
        } catch (err) {
          // console.log(err);
        }
      }
      else{
        Swal.fire({
            title:
              "Debe ingresar al Padre o Madre del recién nacido."
          });
      }
    },
    selectFiles() {
      this.files = this.$refs.files.files;
      let count = 1;
      let a = [];
      let fs = this.files;
      Array.prototype.forEach.call(fs, function(f) {
        let reader = new FileReader();
        // Closure to capture the file information.
        reader.onload = (function(theFile) {
          reader.readAsBinaryString(theFile);
          return function(e) {
            let binaryData = e.target.result;
            //Converting Binary Data to base 64
            let base64String = window.btoa(binaryData);
            //adding file converted to array of images
            a.push(base64String);
          };
        })(f);
      });
      this.files = a;
    }
  }
};
</script>

<style>
.title-class {
  font-size: 1.5em;
}
</style>